import React, { Component } from 'react';
import { FormGroup, Input, Button, Label } from 'reactstrap';

import { compose } from 'recompose';

import { withFirebase } from '../../components/Firebase';
import { withAuthorization } from '../../components/Session';

import * as ROUTES from '../../constants/routes';
import * as CHAVES from '../../constants/chaves';
import MenuAdm from '../../menu/menuAdm';

const INITIAL_STATE = {
    usuarioLogado: {},
    servicos: [],
    servicoEscolhido: '',
    perguntas: null,
    modal: false,
    respostas: [],
    nPerguntas: 0,
    nRespostas: 0,
    areaDeAtuacao: {},
    maisInformacoes: '',
};

class SolicitarBase extends Component {
    constructor(props) {
        super(props);

        this.state = { ...INITIAL_STATE };

        this.onChange = this.onChange.bind(this);
        this.onChangeCombo = this.onChangeCombo.bind(this);

        this.toggle = this.toggle.bind(this);
    }

    componentDidMount() {
        this.listenerUserAutenticado = this.props.firebase.auth.onAuthStateChanged(userAutenticado => {
            userAutenticado
                ? this.setState({ userAutenticado })
                : this.setState({ userAutenticado: null });
        });

        this.listenerUser = this.props.firebase.solicitante(this.props.firebase.auth.currentUser.uid).once('value').then((snapshot) => {
            const usuarioLogado = snapshot.val();
            this.setState({
                usuarioLogado
            });
        });

        // Carrega Serviços
        this.props.firebase.areasDeAtuacao().on('value', snapshot => {
            const servico = snapshot.val();
            if (servico) {
                const areasList = Object.keys(servico).map(key => ({
                    ...servico[key],
                    uid: key,
                }));
                this.setState({
                    servicos: areasList,
                });
            }
        });
    }

    onSubmit = event => {
        event.preventDefault();

        const { areaDeAtuacao, respostas, usuarioLogado, maisInformacoes } = this.state;
        const bairro = usuarioLogado.bairro;
        const cidade = usuarioLogado.cidade;
        const dataHora = new Date().getTime();
        const nomeSolicitante = usuarioLogado.nome;
        const telefoneSolicitante = usuarioLogado.telefone

        // conferir isso depois 
        const tipoLocal = 'casa';
        const uidSolicitante = this.props.firebase.auth.currentUser.uid;

        //criando objeto post
        var posts = [];
        for (var i in respostas) {
            if (respostas.hasOwnProperty(i)) {
                const post = ({
                    audio: false,
                    data: new Date().getTime(),
                    expedito: false,
                    picture: false,
                    texto: respostas[i],
                })
                posts.push(post);
            }
        }

        if (maisInformacoes) {

            const post = ({
                audio: false,
                data: new Date().getTime(),
                expedito: false,
                picture: false,
                texto: maisInformacoes
            });
            posts.push(post);
        }

        const uid = this.props.firebase.abrirChamadoSolicitante(uidSolicitante).push().key;

        this.props.firebase
            .abrirChamadoSolicitante(uidSolicitante).child(uid)
            .set({
                areaDeAtuacao,
                bairro,
                cidade,
                dataHora,
                nomeSolicitante,
                posts,
                somentePremium: true,
                status: CHAVES.CHAMADOS_POR_SOLICITANTE_EM_ABERTO,
                tipoLocal,
                uidSolicitante,
                telefoneSolicitante,
                uid,
                concluido: false,
            })
            .then(() => {
                this.props.history.push(ROUTES.ESCOLHER_PROFISSIONAL);
            });
    }

    onChange = event => {
        this.setState({
            [event.target.name]: event.target.value,
        });
        if ([event.target.name] == 'servicoEscolhido') {
            this.state.servicos.map(servico => {
                if (event.target.value == servico.nome) {
                    this.setState({
                        areaDeAtuacao: servico,
                        perguntas: servico.perguntas,
                        // conta quantos elementos tem o objeto
                        nPerguntas: Object.getOwnPropertyNames(servico.perguntas).length,
                        nRespostas: 0,
                    })
                }
                // apenas para remover alerta
                return true;
            });

        }
    };

    onChangeCombo = event => {
        this.setState({
            respostas: {
                ...this.state.respostas,
                [event.target.name]: event.target.value,
            },
            nRespostas: this.state.nRespostas + 1,
        })
    }


    toggle() {
        this.setState(prevState => ({
            modal: !prevState.modal
        }));
    }

    render() {
        const { servicos, servicoEscolhido, perguntas, maisInformacoes } = this.state;
        const isInvalid = this.state.nPerguntas < (this.state.nRespostas + 2) && this.state.nRespostas > 0;
        return (
            <div>
                <MenuAdm />
                <header className="masthead">
                    <div className="container h-100">
                        <div>
                            <form onSubmit={this.onSubmit}>
                                <div className="divBranca">
                                    <div className="row">
                                        <div className="col direita"><img src={process.env.PUBLIC_URL + './img/expedito.jpg'} width='100' alt='img expedito' /></div>
                                        <div className="col"><h3>Olá, eu sou o Expedito, qual serviço você está precisando?</h3></div>
                                    </div>
                                    <div className="row">
                                        <div className="col">
                                            <FormGroup>
                                                <Label for="servicoEscolhido">Selecione uma área</Label>
                                                <Input type="select" value={servicoEscolhido} name='servicoEscolhido' onChange={this.onChange}>
                                                    <option key="0" >-</option>
                                                    {
                                                        servicos.map(servico => (
                                                            <option key={servico.uid} >{servico.nome}</option>
                                                        ))
                                                    }
                                                </Input>
                                            </FormGroup>
                                        </div>
                                    </div>
                                    {perguntas &&
                                        <div>
                                            {
                                                perguntas.map(pergunta => (
                                                    <div className="row" key={pergunta.uid}>
                                                        <div className="col">
                                                            <FormGroup>
                                                                <Label for="exampleSelect">{pergunta.pergunta}</Label>
                                                                <Input type="select" name={pergunta.pergunta} id={pergunta.pergunta} onChange={this.onChangeCombo}>
                                                                    <option key="0" >-</option>
                                                                    {pergunta.respostas.map(resp => (
                                                                        <option key={resp} >{resp}</option>
                                                                    ))}
                                                                </Input>
                                                            </FormGroup>
                                                        </div>
                                                    </div>
                                                ))
                                            }
                                        </div>
                                    }
                                    <div className="row">
                                        <div className="col">
                                            <FormGroup>
                                                <Label for="maisInformacoes">Deseja acrescentar alguma informação?</Label>
                                                <Input type="textarea"
                                                    name="maisInformacoes"
                                                    id="maisInformacoes"
                                                    value={maisInformacoes}
                                                    onChange={this.onChange} />
                                            </FormGroup>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col direita">
                                            <Button disabled={!isInvalid} type="submit" color="success">Enviar</Button>
                                        </div>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </header>
            </div>

        )
    }
}

const condition = authUser => !!authUser;

const Solicitar = compose(
    withFirebase,
    withAuthorization(condition),
)(SolicitarBase);


export default Solicitar;